import { render, staticRenderFns } from "./UiButton.ts.vue?vue&type=template&id=5a3664a6&scoped=true"
import script from "./UiButton.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiButton.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiButton.ts.vue?vue&type=style&index=0&id=5a3664a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3664a6",
  null
  
)

export default component.exports